import {
  SkeletonText,
  SkeletonTimelineItem,
  SkeletonTimelineContainer,
} from '../styles';

export const MobileTimelineSkeleton = () => {
  return (
    <SkeletonTimelineContainer>
      {[1, 2, 3, 4].map((i) => (
        <SkeletonTimelineItem key={i}>
          <SkeletonText $width="55px" $height="16px" />
          <SkeletonText $width="120px" $height="14px" style={{ flex: 1 }} />
          <SkeletonText $width="85px" $height="24px" style={{ borderRadius: 6 }} />
        </SkeletonTimelineItem>
      ))}
    </SkeletonTimelineContainer>
  );
};

// Keep for backward compatibility if needed
export const MobileSkeleton = MobileTimelineSkeleton;
